import { PayloadAction } from '@reduxjs/toolkit';

import { AppStorage } from '@/shared/constants/app-storage.constant';
import { createSlice } from '@/shared/lib/helpers/create-store-logic';

import { BoatSchema } from '../types/boat.interface';

export const boatSlice = createSlice({
	name: 'boat',
	initialState: {} as BoatSchema,
	reducers: {
		setBoatById: (state, action: PayloadAction<string>) => {
			state.selectedId = action.payload;
			localStorage.setItem(AppStorage.Boat, action.payload);
		},
		resetBoatById: (state) => {
			state.selectedId = undefined;
			localStorage.removeItem(AppStorage.Boat);
		},
	},
});

export const { actions: boatActions, reducer: boatReducer, useActions: useBoatActions } = boatSlice;
